module.exports = __webpack_public_path__ + "media/images/program/ses_stress_triangle-8ffc9d0462e262925bd1f092a290f86d222cc6c42397c2e83ca6f124adfb29f6.png";